import { FileUploadService } from '@/interfaces/services/upload';
import { HttpFileUploadService } from '@/services/upload';

let fileUploadService: FileUploadService | null = null;

export function useFileUploadService(options?: {
  serviceInstance?: FileUploadService;
}): FileUploadService {
  if (options?.serviceInstance) {
    fileUploadService = options.serviceInstance;
    return options.serviceInstance;
  }

  if (!fileUploadService) {
    fileUploadService = new HttpFileUploadService();
  }
  return fileUploadService;
}
